import { observable, runInAction, flow, toJS } from 'mobx';
import { rootStore } from 'stores/RootStore';
import API from 'api';
import * as yup from 'yup';

export default class Patient {
	@observable id: number;

	@observable patientName: string = '';
	@observable patientSurname: string = '';
	@observable patientDOB: string;
	@observable patientMedicare: string = '';
	@observable patientDVA: string = '';
	@observable patientAddress: string;
	@observable patientSuburb: string = '';
	@observable patientPostcode: string = '';
	@observable patientState: string = '';
	@observable patientPhone: string = '';
	@observable patientMobile: string = '';
	@observable patientEmail: string = '';
	@observable patientFAX: string = '';
	@observable patientTitle: string = '';
	@observable ihi: string = '';
	@observable sex: string = '';
	@observable ihiStatus: string = '';
	@observable recordStatus: string = '';
	@observable createdBy: number;
	@observable modifiedBy: number;
	@observable created: string;
	@observable modified: string;
	@observable disabled: boolean = false;

	constructor(data: Patient) {
		if (data) this.extend(data);
	}

	extend(data: Patient = {}) {
		runInAction(() => {
			Object.assign(this, data);
		});
	}

	static ValidationSchemaPatient = yup.object().shape({
		patientName: yup
			.string()
			.label('First name')
			.required(),
		patientSurname: yup
			.string()
			.label('Last name')
			.required(),
		patientMedicare: yup
			.number()
			.label('Medicare Number')
			.required()
	});

	static loadById = async (id: number): Promise<Patient> => {
		let res = await API.get(`/Patients/${id}`);
		return new Patient(res);
	};

	update = async (withData): Promise<Patient> => {
		if (withData) this.extend(withData);
		await Patient.ValidationSchemaPatient.validate(toJS(this), { abortEarly: false });
		return new Promise((resolve, reject) => {
			if (this.id) {
				// Update record
				API.patch(`/Patients/${this.id}`, toJS(this))
					.then(result => {
						resolve(new Patient(result));
					})
					.catch(err => {
						reject(err);
					});
			} else {
				// New record
				API.post(`/Patients`, toJS(this))
					.then(result => {
						this.id = result.id;
						resolve(new Patient(result));
					})
					.catch(err => {
						reject(err);
					});
			}
		});
	};

	static searchByMedicareNo = async (medicareNo: string): Promise<Patient> => {
		const firstPart = medicareNo.slice(0, 9);
		const lastDigit = medicareNo[10];
		const filters = [
			{ patientMedicare: { like: firstPart + '%25' } },
			{ patientMedicare: { like: '%25' + lastDigit } }
		];
		const whereFilter = { and: filters };
		return new Promise((resolve, reject) => {
			API.get(`/Patients?filter=${JSON.stringify({ where: whereFilter })}`)
				.then(results => {
					resolve(results.map(el => new Patient(el)));
				})
				.catch(err => {
					reject(err);
				});
		});
	};

	static callIhi = async (req): Promise => {
		return await API.post(`/IhiActivities/callIhi`, req);
	};

	static updateIhi = async (req): Promise => {
		return await API.post(`/IhiActivities/updateIhi`, req);
	};
}



// WEBPACK FOOTER //
// ./src/stores/Patient.js